import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  visible: boolean = false;
  showLegends: boolean = false;

  onLegendConsultClicked(displayLegend: boolean): void {
    this.showLegends = displayLegend; 
  }

  closeSidebar(): void {
    this.visible = false;
    this.showLegends = false;
  }
}
